import Entity from './entity'

const ClientUnderwritingUpdate = new Entity('clientunderwritingupdates')

export default ClientUnderwritingUpdate
